export enum ProSkillAssureCreateStepType {
  ASSESSMENT_SET = "ASSESSMENT_SET",
  BASIC_INFO = "BASIC_INFO",
  PROCTORING = "PROCTORING"
}